module.exports = __webpack_public_path__ + "img/creelo.6d3c6957.webp";